export function createTileHighlights(highlightResult, fieldName, tokensFieldName) {
  const tokensHighlights = highlightResult[tokensFieldName];
  if (tokensHighlights) {
    const matchedTokenHighlights = tokensHighlights.filter(highlight => highlight.matchLevel !== 'none').map(highlight => highlight.value);
    matchedTokenHighlights.push(highlightResult[fieldName].value);
    return matchedTokenHighlights.join(' ');
  }
  return highlightResult[fieldName].value;
}